import React from "react";
import {connect} from "react-redux";
import {reduxForm, Field, SubmissionError} from "redux-form";
import {compose, withHandlers, lifecycle} from "recompose";
import Button from "react-md/lib/Buttons/Button";
import {forEach, find, sortBy, concat, isEmpty} from "lodash";

import TextField from "../form/TextField";
import AutocompleteField from "../form/AutocompleteField";
import * as Validation from "../form/Validation";

import {
    foundOrganization,
    getPackages,
    getOrganizations
} from "../../actions/resourceActions";
import {createMyAtollonInstance, getAvailablePackageListForAtollonInstance} from "../../actions/organizationActions";
import {getUsers} from "../../actions/userActions";
import {setActiveForm} from "../../actions/appActions";

import * as workInProgress from "../../Atollon/messages/UserMessages";
import SelectField from "../form/SelectField";
import {DebugElement} from "../../Atollon/debug";
import {array_utilities} from "../../Atollon/utilities/array_utilities";
import {
    getOrganizationPackageMapping,
    getOrganizationPackageMapping_forMyOrg
} from "../../actions/OrganizationPackageMappingActions";
import {isAdmin} from "../../utils";
import {postNewRequest} from "../../actions/requestActions";
import {getInstanceNameLabel, getInstanceUrlFromIdent, getApiPrefix_lagoon} from "../../constants";


const serverChoosesCategory = false;
const customPackagesOnly = true;

//
// returns [{ name, description, serverCategory, isCustomPackage }]
//
let getPackagesForInstance = ( state ) =>
{
    let packagesByName = {};
    if( state && state.resource && state.resource.packages )
    {
        forEach( state.resource.packages, p =>
        {
            packagesByName[ p.name ] = p;
        });
    }

    let admin;
    if( state && state.app )
    {
        admin = isAdmin( state.app.role );
    }
    else
    {
        admin = false;
    }


    let customPackages = [];

    console.log( '%cSelect custom package for instance','background:green;color:#fff', {admin} );


    let getPackageDescription = ( customPackage ) =>
    {
        const name = customPackage.packageId;
        const serverCategory = customPackage.serverCategory ? customPackage.serverCategory.shortcut : null;
        const defaultDescription = packagesByName[name] ? packagesByName[name].description : name;
        let description_prefix= '';
        if( admin )
        {
            description_prefix = customPackage.organizationIdentifier ? customPackage.organizationIdentifier : '(generic)';
            description_prefix +=  " | ";
        }
        const description = description_prefix + ( customPackage.productDescription || customPackage.productName || defaultDescription );
        return description;
    };

    //
    // related custom packages
    //
    if( !admin )
    {
        if( state && state.resource && state.resource.organizationPackageMapping_forMyOrg )
        {
            console.log( '%cSelect custom package for instance','background:green;color:#fff', {mypackages: state.resource.organizationPackageMapping_forMyOrg} );
            forEach( state.resource.organizationPackageMapping_forMyOrg, customPackage => {
                //
                // {organizationIdentifier,packageId,serverCategory:{id, name, shortcut}
                //
                const name = customPackage.packageId;
                const serverCategory = customPackage.serverCategory ? customPackage.serverCategory.shortcut : null;
                const description = getPackageDescription( customPackage );
                const id = customPackage.id;
                customPackages.push({name, description, serverCategory, isCustomPackage: true, id });
            });
        }
    }

    //
    // all available custom packages
    //
    if( admin )
    {
        let allCustomPackages = [];
        if(
            state &&
            state.resource &&
            state.resource.organizationPackageMapping
        )
        {
            allCustomPackages = state.resource.organizationPackageMapping;
        }

        let allMyOrganizations = [];
        if(
            state &&
            state.resource.organizations &&
            state.resource.organizations.item
        )
        {
            allMyOrganizations = state.resource.organizations.item;
        }

        {
            //
            // TODO: replace with proper algorithm? That is:
            // - get ADMIN,DISPATCHER,MEMBER organizations
            // - list packages from /api/touch/organizationPackageMapping/forOrg/{organization}
            //
            forEach( allCustomPackages, customPackage => {
                //
                // {organizationIdentifier,packageId,serverCategory:{id, name, shortcut}
                //
                const id = customPackage.id;
                const name = customPackage.packageId;
                const serverCategory = customPackage.serverCategory ? customPackage.serverCategory.shortcut : null;
                // TODO: package have custom name
                const description = getPackageDescription( customPackage );

                forEach( allMyOrganizations, org =>
                {
                    const isFromOrganization = org.identifier === customPackage.organizationIdentifier;
                    // console.log({ '==': isFromOrganization, org, customPackages });
                    if( isFromOrganization || admin )
                    {
                        customPackages.push({ id, name, description, serverCategory, isCustomPackage: true });
                    }
                });
            });
        }
    }

    let instancePackages = [];
    // {
    //     if( state && state.resource && state.resource.productsByOrganization && state.resource.productsByOrganization.default )
    //     {
    //         forEach( state.resource.productsByOrganization.default, item => {
    //             const name = item.name;
    //             const description = item.description; // TODO:
    //             const serverCategory = item.serverCategory;
    //
    //             instancePackages.push({ name, description, serverCategory });
    //         });
    //     }
    // }

    let packages = concat( customPackages, instancePackages );
    let sortedPackages = array_utilities.array_of_structs_locale_sort_by_array_of_field_names( packages, ['description'] );

    console.log( '%cSelect custom package for instance','background:green;color:#fff', {state, instancePackages, customPackages, sortedPackages} );

    if( isEmpty( sortedPackages ))
    {
        return null;
    }
    else
    {
        return sortedPackages;
    }
};

const Form = (inputProps) => {

    let {
        handleSubmit,
        history,
        hostId,
        serverId,
        users,
        getUsers,
        change,
        userOrganization,
        setActiveForm,
        packages,
        productsByOrganization,
        state
    } = inputProps;

    let optionsAutocomplete = [];
    if (users)
    {
        forEach(users, item =>
            optionsAutocomplete.push({
                label: item.name,
                value: item.id
            })
        );
    }

    const atollonPackages = [];

    let packagesList = getPackagesForInstance( state );

    console.log( '%cSelect custom package for instance','background:green;color:#fff', {packagesList} );

    forEach( packagesList, item =>
            atollonPackages.push({
                label: item.description || item.name,
                value: item.id,
                className: item.isCustomPackage ? 'instancePackage--isCustomPackage' : ''
            })
    );

    console.log( {atollonPackages} );

    let productLocale = [];
    productLocale.push({label: "Czech", value: "cs"});
    productLocale.push({label: "English", value: "en"});

    let productName = '';

    return (
        <form onSubmit={handleSubmit} className="form">
            <DebugElement text="src/components/organizationFound/Form.js"/>
            <Field
                component={TextField}
                label="Název instance"
                name="name"
                validate={[Validation.required]}
            />
            <Field
                component={TextField}
                label={getInstanceNameLabel()}
                name="ident"
                validate={[Validation.required, Validation.isAtollonInstanceIdent]}
            />
            {/*
            <Field
                component={TextField}
                label="serverCategory"
                name="serverCategory"
                validate={[Validation.required]}
                className="hidden"
            />
            */}
            <Field
                component={SelectField}
                menuItems={atollonPackages}
                label="Produkt"
                name="customPackageId"
                validate={[Validation.required]}
            />
            <Field
                component={SelectField}
                menuItems={productLocale}
                label="Jazyk instance"
                name="productLocale"
                validate={[Validation.required]}
            />

            <div className="touchButtons-spaceAbove" />

            <div className="flex-row flex-right">
                <Button
                    flat
                    label="Zrušit"
                    className="btn touchButton-3 touchButton-shape3"
                    onClick={() => {
                        if (userOrganization) setActiveForm(null);
                        else history.push(`/hosts/${hostId}/${serverId}`);
                    }}
                />
                <div className="touchButtons-spaceBetween" />
                <Button
                    flat
                    primary
                    label="Založit"
                    type="submit"
                    className="btn btn-primary  touchButton-1 touchButton-shape3"
                />
            </div>
        </form>
    );
};

export default compose(
    connect( inputState => {

        let {
            resource: {
                users,
                organizationUsersAdmin,
                organizationUsersOwner,
                organizationUsersUser,
                packages,
                productsByOrganization
            },
            app: {
                role: roleArray,
                role: { 0: roleArray2 }
            }
        } = inputState;

        return {
            users,
            organizationUsersAdmin,
            organizationUsersOwner,
            organizationUsersUser,
            packages,
            productsByOrganization,
            state: inputState
        }
    }, {
        createMyAtollonInstance,
        getUsers,
        setActiveForm,
        getAvailablePackageListForAtollonInstance: getAvailablePackageListForAtollonInstance,
        getPackages,
        getOrganizationPackageMapping,
        getOrganizationPackageMapping_forMyOrg,
        getOrganizations,
        postNewRequest
    }),
    withHandlers({
        onSubmit: () => async (formData, dispatch, props) => {
            const {
                hostId,
                serverId,
                createMyAtollonInstance,
                history,
                users,
                getState,
                postNewRequest
            } = props;

            let createInstanceParameters = {};
            createInstanceParameters.name = formData.name;
            createInstanceParameters.ident = formData.ident;
            createInstanceParameters.productName = formData.productName;
            createInstanceParameters.productLocale = formData.productLocale;

            function testingData() {
                createInstanceParameters.name = "moje krásná  nová instance  organizace23";
                createInstanceParameters.ident = "ident23";
                createInstanceParameters.serverCategory = "rct-shared";
                createInstanceParameters.productName = "productName23";
                createInstanceParameters.productLocale = "en";
            }


            let userInfo = {
                myEmail:  props.state.app.user.identifier, //getMyEmail( props );
                // companyName:  0, //getCompanyName( props );
                // address1:  0, //getCompanyName( props );
                // region:  0, //getFormDatafromPop( props );
                // address2:  0 //
            };

            let newInstanceRequest = {
                "subject":"Create New Instance",
                "messageBody": `Please create instance '${getInstanceUrlFromIdent(formData.ident)}'.`,
                //
                // "companyName": userInfo.companyName,
                // "address1": userInfo.address1,
                // "address2": userInfo.address2,
                // "region": userInfo.region,
                //
                //"countryCode":"AF",
                "formIdentifier":"com.atollon.form.register",
                //"language":"en-GB",
                "recipients":[{"identifier":"admin"}],
                "customFields":[
                    {"name":            "name", "value": formData.name},
                    {"name":           "ident", "value": formData.ident},
                    {"name": "customPackageId", "value": formData.customPackageId},
                    {"name":   "productLocale", "value": formData.productLocale},

                ],
                "sender": userInfo.myEmail,
                "pendingSide": "RECIPIENT", // Who solves the task? -> atollon
                "status": "INITIAL",
                "type": "ATOLLON_INSTANCE"
            };

            let ok = await postNewRequest({
                url: `${getApiPrefix_lagoon()}/auth/request`,
                data: newInstanceRequest,
                showLoader: true,
                alertBefore:  "Spuštěno předávání instance k založení, pokud proces neskončí do 2 minut, nahlašte nám problém"
            });
            if( ok )
            {
                workInProgress.userMessage_ok( "Instance úspěšně předána k založení.\nProsíme počkejte, zašleme Vám email až bude hotovo." );
                // history.push(`/hosts/${hostId}/${serverId}`);
            }
            else
            {
                workInProgress.userMessage_error( "Chyba při zakládání instance." );
            }
        }
    }),
    lifecycle({
        async componentWillMount() {
            const {
                getAvailablePackageListForAtollonInstance,
                getOrganizationPackageMapping,
                getOrganizationPackageMapping_forMyOrg,
                getOrganizations,
                getPackages,
                state
            } = this.props;
            await getAvailablePackageListForAtollonInstance('default');
            await getOrganizations();
            await getPackages('default');
            await getOrganizationPackageMapping_forMyOrg();
            await getOrganizationPackageMapping(); // for admin packages ... can fail ...
        }
    }),
    reduxForm({form: "organizationFoundForm", enableReinitialize: true})
)(Form);



// WEBPACK FOOTER //
// ./src/components/organizationFound/Form.js